import type { HbBidderConfig } from '../types'

export const NEXVERSE: HbBidderConfig = {
    bidder: 'nexverse',
    countries: { allow: ['IN'] },
    params: {
        uid: 'ad135c38176f14886c99a4ea2d436a8c',
        pubId: '24329',
        pubEpid: '35109',
    },
}
